import styled from "styled-components";

export const Text = styled.div`
  font-weight: 400;
  line-height: 24px;
  font-size: 14px;
  color: var(--Text_Disabled);
  user-select: none;
`;
